export const PanicType = {
  None: 0,
  USSD: 1 << 0,
  Road: 1 << 1,
  Home: 1 << 2,
  Legal: 1 << 3,
  HiJack: 1 << 4,
  HomeInvasion: 1 << 5,
  Medical: 1 << 6,
  HomeDrive: 1 << 7,
} as const;

export type PanicTypeMask = number;

export const PanicMask = {
  has: (mask: PanicTypeMask, flag: number) => (mask & flag) === flag,
  allFlags: () =>
    (Object.values(PanicType).filter(v => typeof v === "number") as number[])
      .filter(v => v !== 0),
};

export const PANIC_OPTIONS: Array<{ value: number; label: string }> = [
  { value: PanicType.Road,         label: "Road" },
  { value: PanicType.USSD,         label: "USSD" },
  { value: PanicType.Home,         label: "Home" },
  { value: PanicType.Legal,        label: "Legal" },
  { value: PanicType.HiJack,       label: "HiJack" },
  { value: PanicType.HomeInvasion, label: "Home Invasion" },
  { value: PanicType.Medical,      label: "Medical" },
  { value: PanicType.HomeDrive,    label: "Home Drive" },
];
